const Form =({children, className="", ...rest})=>{
    return <form className={`flex-1 flex flex-col justify-between ${className}`} {...rest}>{children}</form>
}
export default Form
